import React, { useState, useReducer } from "react";
import {
  Box,
  Grid,
  GridItem,
  Image,
  Text,
  Button,
  useDisclosure,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import ModalContainer from "./ModalContainer";

const projects = [
  {
    title: "Portfolio website",
    description:
      "This project is my personal portfolio, designed in Figma and coded using React and Chakra UI. The portfolio features a clean and modern design,demonstrating ability to conceptualize a design and bring it to life.",
    imageUrl: "asset/p-1.png",
    tools: ["React", "Chakra UI", "Supabase", "Figma"],
    link: "",
    category: "Web",
  },
  {
    title: "Transboundary Website Design",
    description:
      "Transboundary Design is a comprehensive and visually compelling project designed in Figma. It represents a fictional company that specializes in engineering, manufacturing, and delivery services. The design includes detailed layouts for various sections such as company overview, services offered, portfolio of completed projects, client testimonials, and contact information",
    imageUrl: "asset/hero-1.png",
    tools: ["Figma"],
    link: "https://www.figma.com/design/nj7aqz9YNYkl94CPLogWar/TransBoundary?node-id=0-1&t=Q1zADgt97y2sUIPw-0",
    category: "UI/UX",
  },
  {
    title: "Yolo Ice Cream Shop",
    description:
      "Yolo Ice Cream is a vibrant and playful conceptual design for an ice cream shop, created to capture the fun and joy of enjoying delicious treats. Designed in Figma, it features a colorful and inviting aesthetic, with high-quality images and engaging graphics that appeal to ice cream lovers of all ages",
    imageUrl: "asset/hero.png",
    tools: ["Figma"],
    link: "https://www.figma.com/design/rAsGPi6N8tULKXtWrKFGSW/icecream_shop_website?node-id=41-629&t=LpGnZaZiZcKTnOvA-0",
    category: "UI/UX",
  },
  {
    title: "Yolo About Page",
    description: "About page for Yolo Ice Cream Shop",
    imageUrl: "asset/about-1.png",
    tools: ["Figma"],
    link: "https://www.figma.com/design/rAsGPi6N8tULKXtWrKFGSW/icecream_shop_website?node-id=41-629&t=LpGnZaZiZcKTnOvA-0",
    category: "UI/UX",
  },
  {
    title: "Dial A Pizza",
    description:
      "Dial-a-Pizza is a comprehensive and engaging website concept for a pizza delivery company. Designed with a user-friendly interface.",
    imageUrl: "asset/hero-2.png",
    tools: ["Figma"],
    link: "https://www.figma.com/design/vKl59SMbGrfETt7Rhq8B4W/TheBalanceLogoDesign?node-id=63-322&t=WIYAWsOgNejh4nyf-0",
    category: "UI/UX",
  },
  {
    title: "Dial A Pizza",
    description:
      "Dial-a-Pizza is a comprehensive and engaging website concept for a pizza delivery company. Designed with a user-friendly interface.",
    imageUrl: "asset/hero-2.png",
    tools: ["Figma"],
    link: "https://www.figma.com/design/vKl59SMbGrfETt7Rhq8B4W/TheBalanceLogoDesign?node-id=63-322&t=WIYAWsOgNejh4nyf-0",
    category: "UI/UX",
  },
];

const categories = ["All", "Web", "Mobile", "UI/UX"];

const ITEMS_PER_PAGE = 5;

const initialState = {
  filteredProjects: projects,
  currentPage: 1,
  selectedProject: null,
  selectedIndex: 0,
};

const reducer = (state, action) => {
  // tab click case
  // selected project case
  // paginate
};

const PortfolioGrid = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { filteredProjects, currentPage, selectedProject, selectedIndex } =
    state;
  return (
    <>
      <Tabs variant="enclosed" onChange="">
        <TabList
          justifyContent="flex-end"
          gap="20px"
          flexBasis={["100%", "auto"]}
          flexWrap="wrap"
          borderBottom="none"
          p={4}
        >
          {categories.map((category, index) => (
            <Tab
              key={index}
              mb={{ base: "4" }}
              border={{ base: "1px solid #530054", md: "none" }}
              borderRadius="10px"
              // color={
              //   selectedIndex === index ? "#fff !important" : "#000 !important"
              // }
              // bg={
              //   selectedIndex === index
              //     ? "#420043 !important"
              //     : "#eee6ee !important"
              // }
            >
              {category}
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          <TabPanel>
            <Grid
              // templateColumns="repeat(auto-fill, minmax(400px, 1fr))"
              templateColumns={{
                base: "repeat(1, 1fr)",
                md: "repeat(2, 1fr)",
                lg: "repeat(auto-fill, minmax(400px, 1fr))",
                // lg: "repeat(3, 1fr)",
              }}
              gap={8}
            >
              {projects.map((project, index) => (
                <GridItem key={index}>
                  <Box
                    p={4}
                    boxShadow="md"
                    cursor="pointer"
                    // onClick={() => handleProjectClick(project)}
                    transition="transform 0.3s ease, box-shadow 0.3s ease"
                    _hover={{ transform: "scale(1.05)", boxShadow: "lg" }}
                    border="4px solid #fff"
                    borderRadius="10px"
                  >
                    <Image
                      src={project.imageUrl}
                      alt={project.title}
                      borderRadius="10px"
                      mb={2}
                    />
                    <Text fontSize="md" fontWeight="bold" textAlign="center">
                      {project.title}
                    </Text>
                  </Box>
                </GridItem>
              ))}
            </Grid>
            <Box mt={10} display="flex" justifyContent="center">
              {Array.from(
                { length: Math.ceil(projects.length / 2) },
                (_, index) => (
                  <Button
                    key={index}
                    // onClick={() => paginate(index + 1)}
                    mx={1}
                    // disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </Button>
                )
              )}
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>

      {/* {selectedProject && (
        <ModalContainer
          isOpen={isOpen}
          onClose={onClose}
          title={selectedProject.title}
          imageUrl={selectedProject.imageUrl}
          description={selectedProject.description}
          tools={selectedProject.tools}
          link={selectedProject.link}
          buttonText="Launch Project"
        />
      )} */}
    </>
  );
};

export default PortfolioGrid;
